import {ResultError} from "@/api-client";
import Vue from "vue";
import bus from "@/EventBus";

declare module 'vue/types/vue' {
    interface Vue {
        setValidationErrors(validationErrors: ResultError, toastTextIfHasAnyHandledMessages: string | null, validationErrorsFieldName?: string): void;
    }
}

Vue.prototype.setValidationErrors = function (validationErrors: ResultError, toastTextIfHasAnyHandledMessages: string | null, validationErrorsFieldName = "validationErrors") {
    if (validationErrors.hasMessages('concurrency')) {
        bus.publish('concurrency-error-occurred', validationErrors.getAndSetAsHandled('concurrency').join('. '));
    } else {
        this[validationErrorsFieldName] = validationErrors;
        this[validationErrorsFieldName].showToastsIfNecessary(this.$nextTick, toastTextIfHasAnyHandledMessages);
    }
}